export var Experiment;
(function (Experiment) {
    Experiment["EnableSmartlingContextCapture"] = "specs.payments.EnableSmartlingContextCapture";
    Experiment["PayButtonBusinessPremiumPlanText"] = "specs.payments.PayButtonBusinessPremiumPlanText";
    Experiment["PayButtonCrownButton"] = "specs.payments.PayButtonCrownButton";
})(Experiment || (Experiment = {}));
